import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';
import LoadingButton from '../utils/common/LoadingButton.jsx';

const ProcessTicketModal = ({
  openUpdateTicketStatus,
  setOpenUpdateTicketStatus,
  handleSendMessage,
  isLoadingSend,
}) => {
  return (
    <Dialog open={openUpdateTicketStatus} maxWidth={'sm'} fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        Modal title
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setOpenUpdateTicketStatus(false)}
        sx={(theme) => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText>Le ticket est-il traité ?</DialogContentText>
      </DialogContent>
      <DialogActions>
        {isLoadingSend ? (
          <>
            <CircularProgress size={16} />
            <Typography sx={{ marginRight: 1 }}>Chargement...</Typography>
          </>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
            <LoadingButton
              onClick={() =>
                handleSendMessage({ isTicketProcessedByUser: false })
              }
            >
              Non
            </LoadingButton>
            <Button
              onClick={() =>
                handleSendMessage({
                  isTicketProcessedByUser: true,
                })
              }
            >
              Oui
            </Button>
          </Box>
        )}
      </DialogActions>
    </Dialog>
  );
};

export { ProcessTicketModal };
